(function ($) {

    $(document).gp_ready(function () {
        $(".guarantee__form-reset").off().on("click", function(e){
            e.preventDefault();

            gp_ajax({
                url: ghostpress_params.ajax_url + "&action=acra_guarantee_form_reset",
                type: "post",
                dataType: "json",
                show_loading: true
            })
        })
    })


})(jQuery)